import styled from 'styled-components'
import { theme } from '@fe-toolkit/web-components'

export const IconList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.tiny};
  list-style: none;
  margin: 0;
  padding: 0;
`

export const IconListItem = styled.li`
  font-size: ${theme.fontSizes.murmur};
  display: flex;
  align-items: center;
`

export const IconListItemWrapper = styled.div`
  height: ${theme.spacing.medium};
  margin-right: ${theme.spacing.tiny};
  min-width: ${theme.spacing.medium};
  position: relative;
  width: ${theme.spacing.medium};
`
